export const MenuData = [
    {
        title: "HOME",
        url: "/",
        cName: "nav-links",
        icon: "fa fa-home"
    },
    {
        title: "DASHBOARD",
        url: "/Customer",
        cName: "nav-links",
        icon: "fa fa-table"
    },
    {
        title: "CONTACT",
        url: "/ContactUs",
        cName: "nav-links",
        icon: "fa fa-address-book"
    },
    {
        title: "SIGN UP",
        url: "/Register",
        cName: "nav-links-signup",
        icon: "fa fa-sign-in"
    },
    {
        title: "LOGOUT",
        url: "/",
        cName: "nav-links",
        icon: "fa fa-sign-out"
    },
]